export default __webpack_public_path__ + "static/tag-dont-4-dark-eeeadb0f8806fb537200dfd5db19e025d6a344d12c767d4b94ffe98eeccb2985.png";